import { createSlice } from '@reduxjs/toolkit';
import { BUNDLE_STEP_CLEANUP_CONFIG, CREATE_BUNDLE_STEP_KEYS } from './createBundleConsts';


const createInitialState = () => ({
    currentStep: 0,
    isEditMode: false,
    editBundleId: null,
    originalSteps: null,
    steps: {
        [CREATE_BUNDLE_STEP_KEYS.BUNDLE_DETAILS]: {
            name: '',
            description: '',
            activityItemIds: [],
            paramTypes: []
        },
        [CREATE_BUNDLE_STEP_KEYS.PRICING]: {
            pricingItems: [],
            editingPricingKeys: [],
            somePricingHasUnsavedEdits: false
        },
        [CREATE_BUNDLE_STEP_KEYS.RULES]: {
            rulesList: [],
            editingRuleKeys: [],
            someRuleHasUnsavedEdits: false
        }
    }
});

const initialState = createInitialState();

export const bundleStateSlice = createSlice({
    name: 'bundleState',
    initialState,
    reducers: {
        setBundleCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        saveBundleStepData: (state, action) => {
            const { stepKey, data } = action.payload;
            if (!stepKey) return;
            state.steps[stepKey] = {
                ...state.steps[stepKey],
                ...data
            };
        },
        cleanupBundleStepDraft: (state, action) => {
            const { stepKey } = action.payload;
            const stepData = state.steps[stepKey];
            if (!stepData) return;

            const config = BUNDLE_STEP_CLEANUP_CONFIG[stepKey];
            if (!config) return;

            const { listKey, editingKey, unsavedFlag } = config;
            stepData[listKey] = (stepData[listKey] || []).filter(item => !item.isNew);
            stepData[editingKey] = [];
            stepData[unsavedFlag] = false;
        },
        initializeBundleForEdit: (state, action) => {
            const { editBundleId, bundleDetails, pricingItems, rulesList } = action.payload;
            state.isEditMode = true;
            state.editBundleId = editBundleId;
            state.currentStep = 0;

            const bundleDetailsData = {
                ...createInitialState().steps[CREATE_BUNDLE_STEP_KEYS.BUNDLE_DETAILS],
                ...bundleDetails
            };
            const pricingData = {
                ...createInitialState().steps[CREATE_BUNDLE_STEP_KEYS.PRICING],
                pricingItems: pricingItems || []
            };
            const rulesData = {
                ...createInitialState().steps[CREATE_BUNDLE_STEP_KEYS.RULES],
                rulesList: rulesList || []
            };

            state.steps[CREATE_BUNDLE_STEP_KEYS.BUNDLE_DETAILS] = bundleDetailsData;
            state.steps[CREATE_BUNDLE_STEP_KEYS.PRICING] = pricingData;
            state.steps[CREATE_BUNDLE_STEP_KEYS.RULES] = rulesData;

            state.originalSteps = {
                [CREATE_BUNDLE_STEP_KEYS.BUNDLE_DETAILS]: structuredClone(bundleDetailsData),
                [CREATE_BUNDLE_STEP_KEYS.PRICING]: { pricingItems: structuredClone(pricingItems || []) },
                [CREATE_BUNDLE_STEP_KEYS.RULES]: { rulesList: structuredClone(rulesList || []) }
            };
        },
        resetCreateBundleState: () => createInitialState()
    }
});

export const {
    setBundleCurrentStep,
    saveBundleStepData,
    cleanupBundleStepDraft,
    initializeBundleForEdit,
    resetCreateBundleState
} = bundleStateSlice.actions;

export default bundleStateSlice.reducer;
